<template>
  <div class="loading-mask-2">

    <div class="logo">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 241.02 281.3">
        <g class="logo-shape">
          <path d="M234.26,0C219.1,28.15,204,56.34,188.73,84.41c-6.18,11.36-13.58,22-24.25,29.57-18.29,13-38.09,16-59.08,7.27-8.11-3.35-14.34-9.28-19.13-16.52-4-6-7.56-12.2-11-18.48-4.16-7.61-9.92-13-18.57-14.9A25.94,25.94,0,0,0,26.22,89.77c-3.71,13,3.39,27.19,16.37,31.33,6.4,2,13.2,2.93,19.88,4,20,3,35.67,17.16,39.73,36.73,3,14.53-.44,27.69-9.94,39.16a3.59,3.59,0,0,1-2.35,1.2q-44.55.08-89.09,0A6.24,6.24,0,0,1,0,202V0H97.73V68.56a5,5,0,0,0,1.5-1.9q7.45-14.56,14.91-29.16,9.54-18.73,19-37.5Z"/>
          <path d="M234.26,202.19h-2.88q-52,0-103.94.06c-2.23,0-3.18-.76-4.07-2.64-13.18-27.68,4.89-61.22,35.21-65,19.7-2.44,35.57,4.91,48.16,19.9,7.49,8.93,13.12,19,18.38,29.35C228.15,189.85,231.09,195.85,234.26,202.19Z"/>
        </g>
      </svg>
    </div>
    <div>
      {{ message || 'Loading...' }}
    </div>

  </div>
</template>

<script>

export default {
  name: "KmcLoadingMask",
  props: {
    message: {
      type: String,
    },
  },
  setup: function (props, context) {
    return {};
  }
}

</script>

